import { Link, useLocation } from 'react-router-dom';
import { categories } from '../../data/categories';
import './Sidebar.css';

export default function Sidebar({ isOpen, onClose }) {
  const location = useLocation();

  const handleCategoryClick = () => {
    // Close sidebar on mobile when category is clicked
    if (window.innerWidth <= 768) {
      onClose();
    }
  };

  return (
    <>
      {isOpen && <div className="sidebar-overlay" onClick={onClose}></div>}
      <aside className={`sidebar ${isOpen ? 'open' : ''}`}>
        <nav className="sidebar-nav">
          <ul className="category-list">
            {categories.map((category) => {
              const isActive = location.pathname === category.path;
              return (
                <li key={category.id}>
                  <Link
                    to={category.path}
                    className={`category-item ${isActive ? 'active' : ''}`}
                    onClick={handleCategoryClick}
                  >
                    <span className="category-icon">{category.icon}</span>
                    <span className="category-name">{category.name}</span>
                  </Link>
                </li>
              );
            })}
          </ul>
        </nav>
      </aside>
    </>
  );
}
